export const APP_NAME = 'Scribelate';

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  DASHBOARD: '/dashboard',
  PROJECTS: '/projects',
  PROJECT_DETAIL: '/projects/:id',
  VIDEO_PLAYER: '/projects/:projectId/videos/:videoId',
  PLAYER: '/projects/:id/episodes/:episodeId',
  PODCASTS_SEARCH: '/podcasts/search',
  PODCASTS_POPULAR: '/podcasts/popular',
  VOCABULARY: '/vocabulary',
  VOCABULARY_REVIEW: '/vocabulary/review',
  JOURNALS: '/journals',
  JOURNAL_DETAIL: '/journals/:journalId',
  JOURNAL_ENTRY_NEW: '/journals/:journalId/entries/new',
  JOURNAL_ENTRY: '/journals/:journalId/entries/:entryId',
  REPORTS: '/reports',
  STORYTIME: '/storytime',
  SETTINGS: '/settings',
  SUBSCRIPTION: '/subscription',
  HELP: '/help',
  PRIVACY: '/privacy',
  TERMS: '/terms',
  DMCA: '/dmca',
} as const;

export const PLAYBACK_SPEEDS = [0.5, 0.75, 1.0, 1.25, 1.5, 1.75, 2.0];

// UI languages - languages with full translation support
export const UI_LANGUAGES = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'es', name: 'Spanish', nativeName: 'Español' },
  { code: 'ja', name: 'Japanese', nativeName: '日本語' },
  { code: 'hi', name: 'Hindi', nativeName: 'हिन्दी' },
  { code: 'ta', name: 'Tamil', nativeName: 'தமிழ்' },
] as const;

// Content languages - languages supported for podcast/project content
export const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'es', name: 'Spanish', nativeName: 'Español' },
  { code: 'ja', name: 'Japanese', nativeName: '日本語' },
  { code: 'fr', name: 'French', nativeName: 'Français' },
  { code: 'de', name: 'German', nativeName: 'Deutsch' },
  { code: 'it', name: 'Italian', nativeName: 'Italiano' },
  { code: 'zh', name: 'Chinese', nativeName: '中文' },
  { code: 'ru', name: 'Russian', nativeName: 'Русский' },
  { code: 'pt', name: 'Portuguese', nativeName: 'Português' },
  { code: 'ko', name: 'Korean', nativeName: '한국어' },
  { code: 'tr', name: 'Turkish', nativeName: 'Türkçe' },
  { code: 'hi', name: 'Hindi', nativeName: 'हिन्दी' },
  { code: 'ta', name: 'Tamil', nativeName: 'தமிழ்' }
] as const;

export const DEFAULT_LANGUAGE = 'en';
